module.exports = __webpack_public_path__ + "static/media/expo_back.1c7368bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/image/expo_back.png
// module id = 288
// module chunks = 0